import { useEffect } from 'react';
import { useColorContext } from '../contexts/ColorContext';
import { ColorComparePanel } from '../components/ColorComparePanel';
import { useToolInit } from '../hooks/useToolInit';

export function CompareTool() {
  const { result, setInput, copiedField, copyToClipboard } = useColorContext();
  const { params } = useToolInit();

  // Deep-link: ?fg= sets global color, ?bg= seeds second color
  useEffect(() => {
    if (params.fg) setInput(params.fg);
  }, [params.fg, setInput]);

  return (
    <ColorComparePanel
      initialColor1={params.fg ?? result?.hex ?? '#3b82f6'}
      initialColor2={params.bg ?? '#ffffff'}
      copiedField={copiedField}
      onCopy={copyToClipboard}
    />
  );
}
